module.exports = __webpack_public_path__ + "img/lineas.5ff4df75.jpg";